<!--
    校区信息-编辑
    功能：校区信息-编辑
-->
<template>
  <div class="department_info" v-loading="loading">
    <el-form :rules="rules" ref="form" :model="form" label-width="110px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="校区名称：" prop="name">
            <el-input v-model="form.name" placeholder="请输入校区名称"></el-input>
          </el-form-item>
          <el-form-item label="品牌名称：">
            <el-input v-model="form.brand" placeholder="请输入品牌名称"></el-input>
          </el-form-item>
<!--          <el-form-item label="总校代付：">-->
<!--            <el-radio v-model="form.is_pil" :label="1">开启</el-radio>-->
<!--            <el-radio v-model="form.is_pil" :label="2">关闭</el-radio>-->
<!--          </el-form-item>-->
          <el-form-item label="所属类目：" prop="school_categories">
            <el-select multiple clearable v-model="form.school_categories" placeholder="请选择类目">
              <el-option
                v-for="item in category"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区：">
            <el-cascader
              :options="chinaJSON"
              v-model="places"
              @change="handleChange"
              placeholder="请选择所在地区"
            />
            <el-input class="address" v-model="form.street" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="校长：">
            <el-input v-model="form.user_name" placeholder="请输入校长姓名"></el-input>
          </el-form-item>
          <el-form-item label="校长电话：">{{ form.user_mobile }}</el-form-item>
          <el-form-item label="邮箱：">
            <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
          <el-form-item label="入驻时间：">{{ data.created_at }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="logo：">
            <AppUploadScale
              v-model="form.logo"
              :common="true"
              class="form_img"
              @on-success="getThumbnailrUrl" />
          </el-form-item>
          <el-form-item label="公司全称：" class="company">
            <el-input v-model="form.company_name" placeholder="请输入公司全称"></el-input>
          </el-form-item>
          <el-form-item label="统一社会代码：" class="company">
            <el-input v-model="form.company_code" placeholder="请输入统一社会代码"></el-input>
          </el-form-item>
          <el-form-item label="营业执照上传：">
            <AppUploadScale
              v-model="form.company_license_img"
              :common="true"
              class="form_img"
              @on-success="getThumbnailrUrlCompany" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </el-form>
  </div>
</template>

<script>
import baseUrl from "../../utils/api";

export default {
  name: "DepartmentInfo",
  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      data: {},
      places: [],
      form: {
        name: '',
        brand: '',
        is_pil: 2,
        school_categories: [],
        province: '',
        city: '',
        area: '',
        street: '',
        user_name: '',
        user_mobile: '',
        email: '',
        created_at: '',
        logo: '',
        company_name: '',
        company_license_img: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入校区', trigger: 'blur' },
        ],
        school_categories: [
          { required: true, message: '请选择类目' }
        ]
      },
      chinaJSON: this.$assets.chinaJSON,
      category: this.$store.state.schoolCategory,
    }
  },
  // computed: {
  //   category() {
  //     return this.$store.state.schoolCategory;
  //   }
  // },
  created() {
    this.data = this.form;
    this.loading = true;
    this.$http.get(`${baseUrl}/api/clients/${this.id}`)
      .then((res) => {
        this.loading = false;
        this.data = res;
        this.form = res.review_last;
        const province = res.review_last.province && res.review_last.province !== '' ? this.chinaJSON.find(item => item.label === res.review_last.province) : ''; // 所在省
        const city= res.review_last.city && res.review_last.city !== '' ? province.children.find(item => item.label === res.review_last.city) : ''; // 所在市
        const area= res.review_last.area && res.review_last.area !== '' ? city.children.find(item => item.label ===res.review_last.area) : ''; // 所在区
        this.places = [province.value ? province.value : '', city.value ? city.value : '', area.value ? area.value : ''];
      })
      .catch((err) => {
        this.loading = false;
        this.$message.error(err.message);
      });
  },
  methods: {
    // 选择地址
    handleChange(val) {
      const province = val[0] ? this.chinaJSON.find(item => item.value === val[0]) : ''; // 所在省
      const city= val[1] ? province.children.find(item => item.value === val[1]) : ''; // 所在市
      const area= val[2] ? city.children.find(item => item.value === val[2]) : ''; // 所在区
      this.form.province = province.label;
      this.form.city = city.label;
      this.form.area = area.label;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交保存
          this.$http.put(`${baseUrl}/api/clients/${this.id}`, this.form)
            .then((res) => {
              this.$message.success('提交成功！');
              setTimeout(() => {
                this.$router.back();
              }, 2000);
            })
            .catch((err) => {
              this.$message.error(err.message);
            });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getThumbnailrUrl(url) {
      this.$nextTick(() => {
        this.form.logo = url;
      });
      this.$forceUpdate();
    },
    getThumbnailrUrlCompany(url) {
      this.$nextTick(() => {
        this.form.company_license_img = url;
      });
      this.$forceUpdate();
    }
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  padding-right: 15%;
}
.address {
  width: calc(100% - 205px);
}
.el-select {
  width: 100%;
}
.form_img {
  width: 200px;
  min-height: 100px;
  height: auto;
}
.image {
  width: 200px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Index/info.vue